import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=406852ef&scoped=true"
import script from "./Detail.vue?vue&type=script&setup=true&lang=js"
export * from "./Detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=406852ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406852ef",
  null
  
)

export default component.exports